import { Navigate, useRoutes } from 'react-router-dom';
import { useGeneralRoutes } from 'routes/useGeneralRoutes';

import { StytchAuthCallback } from 'pages/StytchAuthCallback';
import { StytchLogin } from 'pages/StytchLogin';

import { AuthLayout } from 'layout/AuthLayout';

export function PublicRouter() {
  const generalRoutes = useGeneralRoutes();
  const routes = useRoutes([
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        { element: <StytchLogin />, index: true },
        { path: 'authenticate', element: <StytchAuthCallback /> },
        ...generalRoutes,

        { path: 'revenue', element: <StytchLogin /> },
        { path: '*', element: <Navigate to="/" /> },
      ],
    },
  ]);

  return routes;
}
